import React, { forwardRef } from 'react'
import classNames from 'classnames'

import './TextInput.scss'

/**
 * @import import { TextInput } from '@/components/forms/TextInput'
 * @param {object} props
 * @param {boolean} [props.error] Critical border and ring, matching field error styling
 * @param {boolean} [props.small] Compact height, matching small buttons and inline entries
 * @param {node} [props.endAction] Small control (e.g. an icon-only CopyButton) overlaid at the field's end; the input reserves room for it
 * @param {string} [props.className] Additional classes on the input element
 */
export const TextInput = forwardRef(function TextInput(
  { className, error = false, small = false, endAction = null, ...props },
  ref
) {
  const input = (
    <input
      className={classNames('text-input', { error, small, 'has-end-action': endAction }, className)}
      ref={ref}
      {...props}
    />
  )

  if (!endAction) {
    return input
  }

  return (
    <div className="text-input-wrapper">
      {input}
      <div className="text-input-end-action">{endAction}</div>
    </div>
  )
})
